import classNames from 'classnames';
import React from 'react';
import './DesignerBody.less';

export const DesignerBody = React.forwardRef(
  ({ children, className }: React.HTMLProps<HTMLDivElement>, ref: React.Ref<HTMLDivElement>) => {
    return (
      <div ref={ref} className={classNames('dpc-designer-body', className)}>
        {children}
      </div>
    );
  }
);
